import { ChainID } from '@jdiyield/constants'
import { APR, Contract, PriceList, Stake, Token } from '@jdiyield/interfaces'
import axios from 'axios'
import throat from 'throat'
import Web3 from 'web3'

import JOEABI from '../abi/joe.json'
import { calculate } from '../calculate'
import getNodeUrl from '../rpcRandom'
import { findToken, makeBatchRequest } from '../utils'

export const getJOE = async (
  walletAddress: string,
  ct: Contract,
  tokens: Token[],
  priceList: PriceList,
  web3Prop: Web3
): Promise<Stake[]> => {
  try {
    const { contractAddress, rewardAddress, routerAddress, pendingReward } = ct
    const web3 = web3Prop || new Web3(getNodeUrl(43114))
    const contract = new web3.eth.Contract(JOEABI as any, contractAddress)

    const _poolLength = await contract.methods
      .poolLength()
      .call()
      .catch(() => 1)
    const poolArray = [...Array(parseInt(_poolLength))]

    let _userInfoResults = []

    _userInfoResults = await makeBatchRequest(
      web3,
      poolArray.map((_data, poolId) => {
        return contract.methods.userInfo(poolId, walletAddress).call
      })
    )

    const _balances = _userInfoResults.map((result, poolId) => {
      let balance = '0'
      let rewardDebt = '0'
      balance = result['amount']
      rewardDebt = result['rewardDebt']
      return { pool: poolId, balance: balance || '0', rewardDebt: rewardDebt || '0' }
    })

    const poolWhiteList = _balances.filter(({ balance }) => +balance > 0).map(({ pool }) => pool)
    const filteredBalance = _balances.filter(({ pool }) => poolWhiteList.includes(pool))
    const _balancesLP = await makeBatchRequest(
      web3,

      filteredBalance.map((b) => contract.methods.poolInfo(b.pool).call)
    )
    const _balancesLPResult = _balancesLP.map((obj, i) => ({ ...filteredBalance[i], lpAddress: obj['lpToken'] }))
    const _balanceLPPair = _balancesLPResult.map(
      throat(80, async (lp: any) => {
        return calculate(
          web3,
          {
            ...lp,
            reward: lp.rewardDebt,
            rewardAddress
          },
          routerAddress,
          tokens,
          priceList
        )
      })
    )

    const _pendingReward = async () => {
      try {
        const result = await makeBatchRequest(
          web3,
          _balancesLPResult
            .filter(({ pool }) => poolWhiteList.includes(pool))
            .map((lp) => {
              return contract.methods[`${pendingReward}`](lp.pool, walletAddress).call
            })
        )
        return result.map((reward, index) => ({ ..._balancesLPResult[index], reward }))
      } catch (error) {
        return _balancesLPResult.map((lp) => ({ ...lp, reward: 0 }))
      }
    }
    const [completeBalance, completePendingReward] = await Promise.all([Promise.all(_balanceLPPair), _pendingReward()])
    const rewardSymbol = findToken(tokens, rewardAddress)?.symbol ?? '???'
    const hopePrice = priceList[rewardAddress]?.usd ?? 0
    const result = completeBalance
      .filter((obj) => obj !== null)
      .map((i) => {
        const reward = +completePendingReward?.find((a: any) => a.pool === i.pool)?.reward / 1e18 || 0
        return {
          ...i,
          ...ct,
          availableBalanceOf: '0',
          reward,
          rewardSymbol,
          rewardUSD: reward * hopePrice
        } as Stake
      })
    return result
  } catch (e) {
    console.log(e)
    return []
  }
}
